export const mapStyles: google.maps.MapTypeStyle[] = [
  { featureType: 'landscape', stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: 'on' }] },
  { featureType: 'poi', stylers: [{ saturation: -100 }, { lightness: 51 }, { visibility: 'simplified' }] },
  { featureType: 'road.highway', stylers: [{ saturation: -100 }, { visibility: 'simplified' }] },
  { featureType: 'road.arterial', stylers: [{ saturation: -100 }, { lightness: 30 }, { visibility: 'on' }] },
  { featureType: 'road.local', stylers: [{ saturation: -100 }, { lightness: 40 }, { visibility: 'on' }] },
  { featureType: 'transit', stylers: [{ saturation: -100 }, { visibility: 'simplified' }] },
  { featureType: 'administrative.province', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }, { lightness: -25 }, { saturation: -100 }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ hue: '#00ff00' }, { lightness: -25 }, { saturation: -97 }],
  },
]

export const overlayMapStyleDetailed: google.maps.MapTypeStyle[] = [
  { stylers: [{ visibility: 'off' }] },
  { featureType: 'road.highway', stylers: [{ visibility: 'on' }] },
  { featureType: 'road.arterial', stylers: [{ visibility: 'on' }] },
  { featureType: 'road.local', stylers: [{ visibility: 'on' }] },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: -85,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f0f0f0',
      },
      {
        weight: 2.5,
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        lightness: -30,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#e0e0e0',
      },
      {
        weight: 2,
      },
    ],
  },
  {
    featureType: 'administrative.province',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: -5,
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  { featureType: 'administrative.locality', stylers: [{ visibility: 'on' }] },
  { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.park', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }, { lightness: -25 }, { saturation: -100 }],
  },
  { featureType: 'water', stylers: [{ visibility: 'on' }] },
]

export const overlayMapStylesSimplified: google.maps.MapTypeStyle[] = [
  {
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        lightness: -30,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#e0e0e0',
      },
      {
        weight: 2,
      },
    ],
  },
  {
    featureType: 'administrative.locality',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: -5,
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#bbbbbb',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: -85,
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f0f0f0',
      },
      {
        weight: 2.5,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.local',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: -25,
      },
      {
        visibility: 'off',
      },
    ],
  },
]
